const binding = { modules: {}, dataActions: {} };

    (binding.modules['mod-video-player'] = {
        c: () => require('partner/modules/mod-video-player/mod-video-player.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'mod-video-player',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/mod-video-player'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|mod-video-player|mod-video-player'] = {
                c: () => require('partner/modules/mod-video-player/mod-video-player.view.tsx'),
                cn: '__local__-__local__-mod-video-player'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };